/** Budgets. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enBoBudgets = {
  'bo.budgets.title': 'Budgets',
  'bo.budgets.subtitle':
    'Monthly budget lines of {branch} per cost center and category, with commitments and actual spending.',
  'bo.budgets.noBranch': 'Budget lines belong to a branch.',
  'bo.budgets.add': 'Add budget line',
  'bo.budgets.readOnly': 'Read only — your role cannot create or change budget lines.',
  'bo.budgets.readOnlyApprover':
    'Your role can approve or reject proposed amounts, but cannot create or change budget lines.',
  'bo.budgets.noPermission': 'Your role cannot view budgets.',

  'bo.budgets.periodTitle': 'Period',
  'bo.budgets.periodDesc': 'Budget lines are planned per calendar month.',
  'bo.budgets.prevMonth': 'Previous month',
  'bo.budgets.nextMonth': 'Next month',
  'bo.budgets.thisMonth': 'This month',

  'bo.budgets.listTitle': 'Budget lines · {period}',
  'bo.budgets.listDesc':
    'Approved amount against open commitments and actual spending. Times in {timeZone}.',
  'bo.budgets.empty':
    'No budget lines for {period} yet. They appear once a manager creates and another person approves them.',
  'bo.budgets.emptyManage':
    'No budget lines for {period} yet. Add a line per cost center and category; another person approves its amount.',
  'bo.budgets.refreshing': 'Updating…',
  'bo.budgets.stale': 'Could not refresh — showing the last loaded data.',
  'bo.budgets.total': 'Total',
  'bo.budgets.sodNote':
    'Separation of duties: whoever proposed an amount cannot approve or reject it.',

  'bo.budgets.col.costCenter': 'Cost center',
  'bo.budgets.col.category': 'Category',
  'bo.budgets.col.approved': 'Approved',
  'bo.budgets.col.committed': 'Committed',
  'bo.budgets.col.actual': 'Actual',
  'bo.budgets.col.available': 'Available',
  'bo.budgets.col.utilization': 'Utilization',
  'bo.budgets.col.status': 'Status',
  'bo.budgets.col.proposal': 'Proposed',
  'bo.budgets.col.policy': 'Over budget',

  'bo.budgets.status.draft': 'Draft',
  'bo.budgets.status.approved': 'Approved',
  'bo.budgets.status.revision_pending': 'Revision pending',
  'bo.budgets.status.closed': 'Closed',
  'bo.budgets.policy.block': 'Block',
  'bo.budgets.policy.escalate': 'Escalate',
  'bo.budgets.policy.blockHint':
    'Purchase requests and orders that exceed the available amount are refused.',
  'bo.budgets.policy.escalateHint':
    'Purchases that exceed the available amount need an extra approval.',
  'bo.budgets.overBudget': 'Over budget',
  'bo.budgets.utilizationLabel': 'Utilization {percent}',
  'bo.budgets.revisionNo': 'Revision {revision}',
  'bo.budgets.proposedBy': 'by {name}',
  'bo.budgets.ownProposal': 'You proposed this amount — another person must decide.',

  'bo.budgets.entries': 'Entries',
  'bo.budgets.entriesNamed': 'Entries of {line}',
  'bo.budgets.editNamed': 'Edit {line}',
  'bo.budgets.approveNamed': 'Approve {line}',
  'bo.budgets.rejectNamed': 'Reject {line}',

  'bo.budgets.createTitle': 'New budget line',
  'bo.budgets.createDesc': 'One line per period, cost center and category.',
  'bo.budgets.editTitle': 'Change {line}',
  'bo.budgets.form.createExplain':
    'The amount is a proposal: the line becomes usable once another person approves it.',
  'bo.budgets.form.periodLabel': 'Period (month)',
  'bo.budgets.form.period': 'Choose a month.',
  'bo.budgets.form.costCenterHint': 'E.g. Kitchen, Bar, Operations.',
  'bo.budgets.form.categoryHint': 'E.g. Food ingredients, Beverages, Maintenance.',
  'bo.budgets.form.required': 'Fill in this field.',
  'bo.budgets.form.duplicate':
    'A budget line with this cost center and category already exists for the period.',
  'bo.budgets.form.amount': 'Amount ({currency}, minor units)',
  'bo.budgets.form.amountHint': 'Digits only, without separators.',
  'bo.budgets.form.amountPreview': 'Amount:',
  'bo.budgets.form.amountInvalid': 'Enter a whole amount (digits only).',
  'bo.budgets.form.policy': 'When over budget',
  'bo.budgets.form.notes': 'Notes',
  'bo.budgets.form.createSubmit': 'Propose budget line',
  'bo.budgets.form.noChanges': 'Nothing changed.',
  'bo.budgets.form.reviseApproved':
    'Changing the amount of an approved line opens a revision: the approved amount stays in force until another person approves the new amount. Policy and notes change immediately.',
  'bo.budgets.form.revisePending':
    'A revision is already waiting for approval. A new amount replaces that proposal; the approved amount stays in force until a decision.',
  'bo.budgets.form.reviseDraft':
    'This line is not approved yet. A new amount replaces the proposal and still needs approval by another person.',
  'bo.budgets.created': 'Budget line {line} proposed.',
  'bo.budgets.saved': 'Budget line {line} saved.',
  'bo.budgets.revisionOpened': 'Revision of {line} proposed — waiting for approval.',

  'bo.budgets.approve': 'Approve',
  'bo.budgets.approving': 'Approving…',
  'bo.budgets.approveTitle': 'Approve budget amount',
  'bo.budgets.approveNote': 'Note',
  'bo.budgets.approveNoteHint': 'Saved in the audit log.',
  'bo.budgets.approved': '{line} approved.',
  'bo.budgets.reject': 'Reject',
  'bo.budgets.rejecting': 'Rejecting…',
  'bo.budgets.rejectTitle': 'Reject budget amount',
  'bo.budgets.rejectReason': 'Reason',
  'bo.budgets.rejectReasonHint': 'Required. The proposer sees why the amount was rejected.',
  'bo.budgets.rejectDraftEffect':
    'The line stays a draft without an amount until a new amount is proposed.',
  'bo.budgets.rejectRevisionEffect': 'The previously approved amount stays in force.',
  'bo.budgets.rejected': '{line} rejected.',
  'bo.budgets.selfApproval':
    'You proposed this amount, so you cannot decide on it. Ask another approver.',
  'bo.budgets.decision.line': 'Budget line',
  'bo.budgets.decision.period': 'Period',
  'bo.budgets.decision.current': 'Approved now',
  'bo.budgets.decision.proposed': 'Proposed amount',
  'bo.budgets.decision.proposer': 'Proposed by',

  'bo.budgets.entriesTitle': 'Entries · {line}',
  'bo.budgets.entriesDesc': 'Commitments and actual spending charged to this budget line.',
  'bo.budgets.entriesEmpty':
    'No entries yet. Approved purchase requests and orders add commitments; posted supplier invoices add actual spending.',
  'bo.budgets.entriesNote':
    'Negative amounts release a commitment (e.g. when it becomes actual spending or is cancelled).',
  'bo.budgets.entry.kind': 'Kind',
  'bo.budgets.entry.source': 'Source',
  'bo.budgets.entry.amount': 'Amount',
  'bo.budgets.entry.reason': 'Reason',
  'bo.budgets.entry.createdBy': 'By',
  'bo.budgets.entry.createdAt': 'Time',
  'bo.budgets.entry.commitment': 'Commitment',
  'bo.budgets.entry.actual': 'Actual',
  'bo.budgets.source.purchase_request': 'Purchase request',
  'bo.budgets.source.purchase_order': 'Purchase order',
  'bo.budgets.source.supplier_invoice': 'Supplier invoice',
  'bo.budgets.source.credit_note': 'Credit note',

  'bo.budgets.definitionsTitle': 'Definitions',
  'bo.budgets.definitionsDesc': 'How the server computes each figure.',
  'bo.budgets.definitionsNone': 'No definitions were returned.',
} as const;
